import { makeStyles } from '@mui/styles'
import { appTheme } from '../../theme'

// css style
export const useStyles = makeStyles({
  textField: {
    marginTop: '1rem',
    marginRight: '0.6rem',
    '& .css-gre06o-MuiFormLabel-asterisk': {
      color: '#D50000 '
    }
  },
  accordianContainer: {
    display: 'flex',
    flexDirection: 'column',
    // gap: "16px",
    marginBottom: '2rem',
    marginLeft: '16px',
    [appTheme.breakpoints.down('lg')]: {
      gap: '16px',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    [appTheme.breakpoints.down('md')]: {
      marginBottom: '3rem',
      display: 'block'
    }
  },
  accordian: {
    width: '85%',
    [appTheme.breakpoints.down('lg')]: {
      width: '100%'
    }
  }
})
